module.exports = __webpack_public_path__ + "img/layer-equipment-room.6a5926a0.png";